/**
 * Thẻ bối cảnh — Visual Description (đợt 260922 E4-P1). Logic THUẦN, tách khỏi file import antd để jest chạy được.
 *
 * `description` của bối cảnh là NGUỒN TỪ KỊCH BẢN (slugline + dòng trích + khối luật "SCRIPT LINES BELOW…") — không phải mô tả. Visual
 * Description (`visualDescription`) là đoạn tả sạch do pass AI viết; ảnh nền + prompt clip đọc nó (backend `locationTextFor`).
 */
interface LocLike { id: string; visualDescription?: string | null; description?: string | null }

/** Bối cảnh chưa có Visual Description — nút "Viết Visual Description cho N bối cảnh còn thiếu" (theo danh sách đang hiện). */
export function locationsNeedingVisual<T extends LocLike>(list: T[]): T[] {
  return list.filter((l) => !String(l.visualDescription || '').trim());
}

/** Khối "Nguồn từ kịch bản": có gì để hiện không + số dòng trích (dòng bắt đầu bằng "- " sau khối luật). */
export function sourceView(l: LocLike): { has: boolean; lines: number } {
  const raw = String(l.description || '').trim();
  return { has: !!raw, lines: raw.split('\n').filter((x) => x.trim().startsWith('- ')).length };
}

/** Câu xác nhận viết hàng loạt — không chữ giá. */
export function visualBatchConfirm(n: number): string {
  return `AI viết Visual Description cho ${n} bối cảnh chưa có (tuần tự, dừng ở lỗi đầu tiên). Bản đã có không bị đụng.`;
}
